import React from 'react';
import '../styles/About.css';


function About() {
  return (
    <div>
    <h1>Pagina Sobre</h1>
    </div>
  );
}

export default About;